import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'semadeni',
} as IModuleProps;
